import { render, staticRenderFns } from "./LowStateTypeDashboardStates.vue?vue&type=template&id=2406151d&scoped=true"
import script from "./LowStateTypeDashboardStates.vue?vue&type=script&lang=js"
export * from "./LowStateTypeDashboardStates.vue?vue&type=script&lang=js"
import style0 from "./LowStateTypeDashboardStates.vue?vue&type=style&index=0&id=2406151d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2406151d",
  null
  
)

export default component.exports